/**
 * Tahsilat Şekli — standart değerler (şartname #5).
 *
 * Backend'deki `backend/payment_methods.py` ile BİREBİR aynı olmalıdır.
 * Sunucu `/api/payments/methods` ve `/api/sales-stock/meta` uçlarından da aynı
 * listeyi döndürür; burası ekranların ilk render'ında ek istek beklememesi için
 * tutulan yerel kopyadır.
 *
 * ÖNEMLİ: eski kayıtlarda serbest metin ("Nakit", "kart" gibi) değerler
 * bulunabilir. `paymentMethodLabel` tanımadığı değeri OLDUĞU GİBİ gösterir —
 * böylece geçmiş ödemeler ekranda "—" olarak kaybolmaz.
 */
export const PAYMENT_METHODS = [
  { value: "nakit", label: "Nakit" },
  { value: "sanal_pos", label: "Sanal Pos" },
  { value: "fiziki_pos", label: "Fiziki Pos" },
  { value: "eft", label: "EFT" },
  { value: "dis_pos", label: "Dış Pos" },
];

export const DEFAULT_PAYMENT_METHOD = "nakit";

const LABELS = PAYMENT_METHODS.reduce((acc, m) => {
  acc[m.value] = m.label;
  return acc;
}, {});

export function paymentMethodLabel(value) {
  if (!value) return "—";
  return LABELS[value] || value;
}

/** Ödemeler ekranı kaynak filtresi (şartname #7/#24). */
export const PAYMENT_SOURCES = [
  { value: "all", label: "Tümü" },
  { value: "emanet", label: "Emanetler" },
  { value: "satis", label: "Satış/Tahsilat" },
];

export function paymentSourceLabel(value) {
  if (value === "satis") return "Satış/Tahsilat";
  if (value === "emanet") return "Emanet";
  return value || "—";
}
